import { ChannelUpdateUsernameResponse } from "../proto/ChannelUpdateUsername_pb";
import { GroupUpdateUsernameResponse } from "../proto/GroupUpdateUsername_pb";
import store from "../store";
import { editRoomExtra } from "../store/rooms/actions";
import BaseHandler from "./BaseHandler";

export default class HandleRoomUpdateUsernameResponse extends BaseHandler<GroupUpdateUsernameResponse | ChannelUpdateUsernameResponse> {
  handle() {
    const roomUpdateUsernameResponse = this.response.toObject();
    const room = store.getState().rooms.rooms[roomUpdateUsernameResponse.roomId];

    store.dispatch(
      editRoomExtra({
        roomId: roomUpdateUsernameResponse.roomId,
        [room.channelRoomExtra ? "channelRoomExtra" : "groupRoomExtra"]: {
          privateExtra: undefined,
          publicExtra: {
            username: roomUpdateUsernameResponse.username,
          },
        },
      })
    );
  }
}
